module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Grundschule Löhne-Bahnhof","short_name":"GS Löhne-Bahnhof","start_url":"/","background_color":"#007c34","theme_color":"#007c34","display":"minimal-ui","icon":"src/images/LogoGrundschule.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"1ec6ba02739cd8f2ac3ca528d97571bd"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
